import { Box } from "@mui/material";
import React from "react";

type ModalContentProps = {
	title?: string;
	subtitle?: string;
	image?: string;
	content?: JSX.Element;
	button?: JSX.Element;
};

const ModalContent = ({
	title,
	subtitle,
	image,
	content,
	button,
}: ModalContentProps) => {
	return (
		<div className="flex flex-wrap flex-col-reverse xl:flex-row gap-[50px]">
			<div className="flex flex-col w-[500px] max-w-full">
				{title && (
					<h2
						className="text-2xl font-semibold"
						dangerouslySetInnerHTML={{ __html: title }}
					/>
				)}
				{subtitle && (
					<h3
						className="text-xl font-semibold"
						dangerouslySetInnerHTML={{ __html: subtitle }}
					/>
				)}
				<Box
					className="whitespace-pre-line"
					sx={{
						"& br": {
							display: "none",
						},
					}}
				>
					{content}
				</Box>
			</div>
			<div className="flex flex-col items-end gap-[30px]">
				{image ? (
					<img
						className="w-full xl:w-[406px] h-[285px] max-h-full max-w-full"
						src={image}
						alt={title}
					/>
				) : (
					<div className="w-full xl:w-[406px] h-[285px] max-h-full max-w-full" />
				)}
				<div>{button}</div>
			</div>
		</div>
	);
};

export default ModalContent;
